/*****
 * ====================================================================================
 * Project: noloPathAnalytics jQuery Plugin
 * Description: provides support of various analytics for noloPath pages
 * Author: Ian Cruz @ Nolo
 * Version: 1.0.0
 * jQuery Version: 2.1.3
 * ====================================================================================
 */




// noloPathAnalytics JQUERY PLUGIN
// ====================================================================================
+function ($, window, document, undefined) {
    'use strict';

    // noloPathAnalytics PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    // ================================================================================
    var noloPathAnalytics = function (element, options) {
        this.$element = $(element);
        this.options  = $.extend(true, {}, noloPathAnalytics.DEFAULTS, options);
        this.reportOnly = false;
        this.repeatsAllowed = false;
        this.debugPixel = this.options.debugPixel;

        // initialize the tracking object
        this.$element.data(noloPathAnalytics.FIRENAME, {});

        // Initialize the plugin
        this.init();

        // Confirmation pae binding events
        this.bindConfirmCtaEvents();
    }




    // noloPathAnalytics PLUGIN NAME
    // ================================================================================
    noloPathAnalytics.NAME  = 'noloPathAnalytics';
    noloPathAnalytics.DATANAME = 'nolo.' + noloPathAnalytics.NAME;
    noloPathAnalytics.FIRENAME = noloPathAnalytics.DATANAME + '.Track';




    // noloPathAnalytics VERSION
    // ================================================================================
    noloPathAnalytics.VERSION  = '1.0.0';




    // noloPathAnalytics DEFAULT OPTIONS
    // ================================================================================
    noloPathAnalytics.DEFAULTS = {
        'timestamp': new Date().getTime(),
        'google_id': null,
        'google_ga4_id': null,
        'google_tracking': 'async', // accepts 'traditional' or 'async'
        'urls': {
            'google': {},
            'pixels': {}
        },
        'events': {},
        'debug': false,
        'debugTrace': '#nolopath-analytics',
        'debugPixel': '/path2/service/pixelTest',
        'hiddenQuestions': '.form-hidden-questions',
    }




    // noloPathAnalytics PUBLIC METHODS
    // ================================================================================
    /**
     * Initializes the plugin
     * @params N/A
     * @return undefined
     */
    noloPathAnalytics.prototype.init = function(){
        var options = this.options;
        var debug = options.debug;

        // report that the initialization has started
        // + helps determine if analytics events are triggered outside of this plugin's initialization
        if(debug){
            console.info('noloPathAnalytics init() started.');
        }

        // bind configured events
        this.bindAnalyticsEvents();

        // report that the initialization has finished
        // + all nolopath analytics handlers are now bound and ready
        if(debug){
            console.info('noloPathAnalytics init() completed. Analytics events handlers are now active.');
        }
    }


    noloPathAnalytics.prototype.bindAnalyticsEvents = function(){
        var $elm = this.$element;
        var options = this.options;
        var debug = options.debug;
        var events = options.events;
        var ns = noloPathAnalytics.NAME;
        var methods = this;
        for(var semEvent in events){
            // bind configured sem events and namespace them
            $elm.bind(semEvent+'.'+ns, function(event, params){
                var type = event.type;
                var extra = event.extraParameters;
                var step = params;
                var handlers, fn, fn_name, fn_params, fn_key, fn_extra, proxy, report, msg, trace, repeats_allowed, repeats_attempted, fn_sem_conversion;
                if(typeof extra === 'object'){
                    step = extra.step;
                }
                handlers = events[type][step] || events[type]['default'] || null;
                if(debug){
                    console.groupCollapsed('noloPathAnalytics Event: %o => %o', type, step);
                    console.info('noloPathAnalytics event detected (%o, %o).', type, step);
                    msg = '<p class="sem-debug-msg notice small">noloPathAnalytics Plugin: Event DETECTED!<br />event name: ' + type + '<br />event step: ' + step + '</p>';
                    report = $.proxy(methods['report'], methods, msg);
                    report();
                }
                if(handlers && $.isArray(handlers) && handlers.length > 0){
                    for(var i=0; i < handlers.length; i++){
                        fn_key = handlers[i]['tracking-id'];
                        fn_name = handlers[i]['method'];
                        fn_params = handlers[i]['params'];
                        fn_extra = handlers[i]['extra'] || {};
                        fn_sem_conversion = handlers[i]['use-sem-conversion-sold-tracking'];
                        fn_extra = $.extend(fn_extra, extra);
                        fn = methods[fn_name];

                        // See EHCS-1069 for more details
                        if(fn_sem_conversion) {
                            var is_unsold = options.is_unsold;
                            var is_sem = options.path_type === 'sem';
                            var is_ignored_goal = fn_key.indexOf('semConversion_goal') > -1;

                            if (is_ignored_goal && is_sem && is_unsold) {
                                // Bing/Google pixel fire is skipped under these conditions
                                continue;
                            }
                        }

                        proxy = $.proxy(methods[fn_name], methods, fn_key, fn_params, fn_extra);
                        try {
                            proxy();
                            if(debug){
                                trace = $elm.data(noloPathAnalytics.FIRENAME)[fn_key];
                                repeats_allowed = trace.repeats_allowed;
                                repeats_attempted = trace.repeats_attempted;
                                if (repeats_attempted === 0){
                                    console.log('Success: %o => %o', fn_name, trace);
                                } else {
                                    if (repeats_allowed){
                                        console.log('Success, Repeat(%o): %o => %o', repeats_attempted, fn_name, trace);
                                    } else {
                                        console.log('Fail, Repeat(%o): %o => %o', repeats_attempted, fn_name, trace);
                                    }
                                }
                            }
                        } catch(err) {
                            if(debug){
                                console.error('Unable to call function: %o', fn_name);
                                console.log('Error: %o', err);
                            } else {
                                $.error('Unable to call function: ' + fn_name + ', ' + err);
                            }
                        }
                    }
                }
                if(debug){
                    console.groupEnd();
                }
                return false;
            });
        }
        return false;
    }

    noloPathAnalytics.prototype.bindConfirmCtaEvents = function(){
        if(location.href.includes('confirm')){
            var $linkSemCta = 'a.sem-business-phone';
            var $linkNavCallUs = '.navbar__call-us';
            // var $link = $('body').find('a.voice_cta_tel');
            var self = this;
            [$linkSemCta,$linkNavCallUs].forEach(function($link_identifier,idx){
                var $link = $('body').find($link_identifier);
                if($link){
                    $link.on('click', function(e) {
                        self.triggerEvent('semVoiceCTA','tel');
                    });
                }
            });

        }
    }

    noloPathAnalytics.prototype.triggerEvent = function(event, params){
        var $elm = this.$element;
        var options = this.options;
        var debug = options.debug;
        var $trace = $(options.debugTrace);
        var p = params || 'default';
        var e = {
            'type': event,
            'extraParameters': {
                'step': p,
                }
            };
        if(debug){
            this.report('<p class="sem-debug-msg alert small">semAnalytics Plugin: triggerEvent() function FIRED!<br />event name: ' + event + '<br />event step: ' + p + '</p>');
        }
        $elm.trigger(e);
        return false;
    }


    noloPathAnalytics.prototype.render = function(template, target, data, partials){
        // use Mustache.js to render stuff to the page
        Mustache.parse(template);
        var rendered = Mustache.render(template, data, partials);
        $(target).html(rendered);
        return;
    }


    noloPathAnalytics.prototype.track = function(key, value){
        var $elm = this.$element
        var track = $elm.data(noloPathAnalytics.FIRENAME);
        if (typeof value === 'undefined'){
            return track[key] ? track[key]['status'] : false;
        } else {
            track[key] = value;
            $elm.data(noloPathAnalytics.FIRENAME, track);
        }
        return;
    }

    noloPathAnalytics.prototype.report = function(msg){
        var options = this.options;
        var $trace = $(options.debugTrace);
        var debug = options.debug;
        if(debug){
            try {
                $trace.append(msg);
            } catch(err) {
                console.log('Unable to report analytics event: %o', err);
            }
        }
    }


    noloPathAnalytics.prototype.getTrace = function(key, param, extra){
        var $elm = this.$element
        var track = $elm.data(noloPathAnalytics.FIRENAME);
        var trace = new noloPathAnalyticsTrace(false, key, param, extra);

        return track[key] || trace;
    }


    noloPathAnalytics.prototype.setHiddenField = function(name, value, decodeValue){
        var $elm = this.$element;
        var $hidden = $elm.find(this.options.hiddenQuestions);
        var $field  = $elm.find('input[name="'+name+'"]');

        // determine 'decodeValue'
        if(typeof decodeValue === 'undefined'){
            decodeValue = true;
        }

        // decode value
        if (decodeValue){
            value = decodeURIComponent(value);
        }

        if ($field.length > 0){
            // update the field value
            $field.val(value);
        } else {
            // add the field
            $field = '<input type="hidden" name="'+name+'" value="'+value+'" />';
            $hidden.append($field);
        }

        return;
    }


    noloPathAnalytics.prototype.setPixel = function(pixel){
        var image;
        try {
            // create the pixel
            image = new Image(1,1);
            image.src = pixel;

            // make sure the pixel is not visible
            image.style = "position: absolute; left: -1px; bottom: -1px;";

            // render the pixel to the document
            document.body.appendChild(image);
        } catch(err) {
            console.log('Unable to create pixel: '+ pixel);
        }
    }


    /*****
     * setAccount()
     * - calls upon the _setAccount method of google analytics
     * - included for reporting and debugging purposes.
     * - the actual method will fire automatically from page load
     * + params: param (string)
     */
    noloPathAnalytics.prototype.setAccount = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_setAccount' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // determine the google analytics account id
        var google_id = options.google_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // fire analytics if setAccount function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            // fire only console commands
            if(google_tracking === 'traditional'){
                msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: setAccount() function FIRED!<br /> Google Analytics Tracking Code: TRADITIONAL<br /> google_id: '+google_id+'<br /> method key: '+key+' <br /> method call: _gat._createTracker()._setAccount()<br /> method param: '+param+'</p>';

                // set trace messages for output
                trace.setMessage('semAnalytics Plugin: setAccount() function FIRED!');
                trace.setMessage('Google Analytics Tracking Code', 'TRADITIONAL');
                trace.setMessage('google_id', google_id);
                trace.setMessage('method key', key);
                trace.setMessage('method call', '_gat._createTracker()._setAccount()');
                trace.setMessage('method param', param);
            } else if(google_tracking === 'async') {
                msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: setAccount() function FIRED!<br /> Google Analytics Tracking Code: ASYNCHRONOUS<br /> google_id: '+google_id+'<br /> method key: '+key+' <br />method call: _gaq.push(["_setAccount"]<br /> method param: '+param+'</p>';

                // set trace messages for output
                trace.setMessage('semAnalytics Plugin: setAccount() function FIRED!');
                trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                trace.setMessage('google_id', google_id);
                trace.setMessage('method key', key);
                trace.setMessage('method call', '_gaq.push(["_setAccount"]');
                trace.setMessage('method param', param);
            }

            // report to the frontend
            this.report(msg);
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);

        return false;
    }


    /*****
     * trackPage()
     * - calls upon the _trackPageview method of google analytics
     * + params: param (string)
     */
    noloPathAnalytics.prototype.trackPage = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackPageview' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // determine the google analytics account id
        var google_id = options.google_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // determine url viewed
        var url = param;
        var src = escape(window.location.pathname);
        var url_with_src = url ? url+'?src='+src : src;

        // fire analytics if trackPage function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            if(debug){
                // fire only console commands
                if(google_tracking === 'traditional'){
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackPage() function FIRED!<br /> Google Analytics Tracking Code: TRADITIONAL<br /> google_id: '+google_id+'<br /> method key: '+key+' <br /> method call: _gat._createTracker()._trackPageview()<br /> method param: '+url_with_src+'</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackPage() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'TRADITIONAL');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gat._createTracker()._trackPageview()');
                    trace.setMessage('method param', url_with_src);
                } else if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackPage() function FIRED!<br /> Google Analytics Tracking Code: ASYNCHRONOUS<br /> google_id: '+google_id+'<br /> method key: '+key+' <br />method call: _gaq.push(["_trackPageview"]<br /> method param: '+url_with_src+'</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackPage() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq.push(["_trackPageview"]');
                    trace.setMessage('method param', url_with_src);
                }

                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'traditional'){
                        // fire the _trackPageview method to google
                        try {
                            var pageTracker = _gat._createTracker(google_id);
                            pageTracker._trackPageview(url_with_src);
                        } catch(err) {
                            console.log('Unable to call google analytics traditional method: _trackPageview');
                        }
                    } else if(google_tracking === 'async') {
                        // fire the _trackPageview method to google
                        try {
                            _gaq.push(['_trackPageview', url_with_src]);
                        } catch(err) {
                            console.log('Unable to call google analytics traditional method: _trackPageview');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);

        return false;
    }

    /*****
     * trackPageView()
     * - calls upon the _trackPageview method of google analytics
     * + params: param (string)
     */
    noloPathAnalytics.prototype.trackPageView = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackPageview' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // determine the google analytics 4 account id
        var google_id = options.google_ga4_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "total_pageviews")
        var category = 'Page Load';

        // the required 'action' parameter defines the action of the event (e.g. "Page Load")
        var action = 'total_pageviews';

        var opt_label = 'page_view';

        // determine url viewed
        var url = param;
        var src = escape(window.location.pathname);
        var url_with_src = url ? url+'?src='+src : src;
        var page_url = window.location.href;

        var gtagFieldsObject = {
            send_to: google_id,
            event_category: category,
            event_label: opt_label,
            url_with_src: url_with_src,
            page_url: page_url
        };

        var	cOptions = {
            'expires' : 86400,
            'path'    : location.pathname,
            'domain'  : location.host,
            'secure'  : false
        }

        var unique_pageview = false;

        if( !Cookies.get('unique_pageviews') &&
            !(Cookies.get('OptanonConsent').includes('C0003') || Cookies.get('OptanonConsent').includes('C0004'))
            // One Trust Compliance
        ) {
            Cookies.set('unique_pageviews', window.location.href, cOptions);
            unique_pageview = true;
            console.log('leave cookie for unique view')
        }



        // fire analytics if trackPage function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            if(debug){
                // fire only console commands
                if(google_tracking === 'traditional'){
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackPageView() function FIRED!<br /> Google Analytics Tracking Code: TRADITIONAL<br /> google_id: '+google_id+'<br /> method key: '+key+' <br /> method call: _gat._createTracker()._trackPageview()<br /> method param: '+url_with_src+'</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackPageView() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'TRADITIONAL');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gat._createTracker()._trackPageview()');
                    trace.setMessage('method param', url_with_src);
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                } else if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackPageView() function FIRED!<br /> Google Analytics Tracking Code: ASYNCHRONOUS<br /> google_id: '+google_id+'<br /> method key: '+key+' <br />method call: _gaq.push(["_trackPageview"]<br /> method param: '+url_with_src+'</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackPageView() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq.push(["_trackPageview"]');
                    trace.setMessage('method param', url_with_src);
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                }

                // report to the frontend
                this.report(msg);
            } else {
                if(google_tracking === 'traditional'){
                    // fire the _trackPageview method to google
                    try {
                        var pageTracker = _gat._createTracker(google_id);
                        pageTracker._trackPageview(url_with_src);
                        gtag('event', action, gtagFieldsObject);
                        if(unique_pageview) {
                            gtagFieldsObject['unique_pageviews'] = true;
                            gtag('event', 'unique_pageviews', gtagFieldsObject);
                        }
                    } catch(err) {
                        console.log('Unable to call google analytics traditional method: _trackPageview');
                    }
                } else if(google_tracking === 'async') {
                    // fire the _trackPageview method to google
                    try {
                        gtag('event', action, gtagFieldsObject);
                        if(unique_pageview) {
                            gtagFieldsObject['unique_pageviews'] = true;
                            gtag('event', 'unique_pageviews', gtagFieldsObject);
                        }
                    } catch(err) {
                        console.log('Unable to call google analytics traditional method: _trackPageview');
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);

        return false;
    }

    /*****
     * trackEvent()
     * - calls upon the _trackEvent method of google analytics
     * + params: param (string)
     */
    noloPathAnalytics.prototype.trackEvent = function(key, param, extra) {
        // grab options
        if (extra.regionGeneral){
            param = param.replace('!_regionGeneral', extra.regionGeneral);
        } else {
            param = param.replace('_!_regionGeneral', 'undefined_region');
        }
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // determine the google analytics account id
        var google_id = options.google_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.category;

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action = extra.action;

        // the optional 'label' parameter provides a more detailed descriptor of the event for reporting
        var opt_label = extra.opt_label || '';

        // the optional 'value' parameter is required to be a number
        var opt_value = $.isNumeric(extra.opt_value) ? Number(extra.opt_value) : 0;

        // the optional 'noninteraction' parameter is required to be a boolean
        // -----
        // @note
        // + by default, Google Analytics sets this value to false, if not declared explicitly
        // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
        //   if not explicitly declared through the configuration
        var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

        // ensure that category parameter is labeled properly with the path name
        category = category.replace('!_pathName', extra.path);

        // ensure that category parameter is labeled properly with the path loader
        if (extra.loader){
            category = category.replace('!_pathLoader', extra.loader);
        } else {
            category = category.replace('_!_pathLoader', '');
        }

        // ensure that region parameter is labeled properly with the region id
        category = category.replace('!_regionId', extra.region);
        action = action.replace('!_regionId', extra.region);
        opt_label = opt_label.replace('!_regionId', extra.region);

        // fire analytics if trackEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            if(debug){
                // fire only console commands
                if(google_tracking === 'traditional'){
                    msg = '<p class="sem-debug-msg alert small">semAnalytics Plugin: trackEvent() function FIRED!<br />Google Analytics Tracking Code: TRADITIONAL<br />ERROR: Unable to call google analytics traditional method: _trackPageview. This method is not available for the loaded google analytics code.</p>';

                    // set trace messages for output
                    trace.setAlert('error');
                    trace.setMessage('semAnalytics Plugin: trackEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'TRADITIONAL');
                    trace.setMessage('ERROR', 'Unable to call google analytics traditional method, "_trackPageview". This method is not available for the loaded google analytics code.');
                    trace.setMessage('method key', key);
                } else if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq.push(["_trackEvent"]');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, opt_label',  opt_label);
                    trace.setMessage('method param, opt_value',  opt_value);
                    trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'traditional'){
                        // fire the _trackPageview method to google
                        console.log('Unable to call google analytics traditional method: _trackPageview. This method is not available for the loaded google analytics code.');
                    } else if(google_tracking === 'async') {
                        // fire the _trackEvent method to google
                        try {
                            _gaq.push(['_trackEvent', category, action, opt_label, opt_value, opt_noninteraction]);
                        } catch(err) {
                            console.log('1.Unable to call google analytics asynchronous method: _trackEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);

        return false;
    }

    noloPathAnalytics.prototype.disqualifyFunnel = function(key, param, extra) {
        if (window.location.href.indexOf("disqualified") > -1) {
            // grab options
            var options = this.options;

            // determine if this will actually trigger google analytics '_trackEvent' method
            var debug = options.debug;

            // determine if this event has ran before
            var track = this.track(key);

            // trace object for storing tracking information
            var trace = this.getTrace(key, param, extra);

            // messages array for outputting the debugging messages
            var msg = [];

            // determine if repeated triggers of this analytics handler is allowed
            var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

            // determine if this is for reporting only
            var report_only = this.reportOnly;
            if(typeof extra === 'object'){
                report_only = extra.report_only || report_only;
            }

            // determine the google analytics account id
            var google_id = options.google_id;

            // determine the google analytics code being used
            var google_tracking = options.google_tracking;

            // the required 'category' parameter defines the general event category (e.g. "Videos")
            var category = extra.category;

            // the required 'action' parameter defines the action of the event (e.g. "Play")
            var action = extra.action;

            // the optional 'label' parameter provides a more detailed descriptor of the event for reporting
            var opt_label = extra.opt_label || '';

            // the optional 'value' parameter is required to be a number
            var opt_value = $.isNumeric(extra.opt_value) ? Number(extra.opt_value) : 0;

            // the optional 'noninteraction' parameter is required to be a boolean
            // -----
            // @note
            // + by default, Google Analytics sets this value to false, if not declared explicitly
            // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
            //   if not explicitly declared through the configuration
            var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

            // fire analytics if trackFunnelEvent function was not fired before
            if(!track || repeats_allowed){
                // indicate tracking status to true
                trace.status = true;

                // set alert type
                trace.setAlert('info');

                var gtagFieldsObject = {
                    send_to: google_id,
                    event_category: category,
                    event_label: opt_label,
                    nonInteraction: opt_noninteraction
                };
                if(debug){
                    // fire only console commands
                    if(google_tracking === 'async') {
                        msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                        // set trace messages for output
                        trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                        trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                        trace.setMessage('google_id', google_id);
                        trace.setMessage('method key', key);
                        trace.setMessage('method call', '_gaq("send")');
                        trace.setMessage('method param, category', category);
                        trace.setMessage('method param, action',  action);
                        trace.setMessage('method param, opt_label',  opt_label);
                        trace.setMessage('method param, opt_value',  opt_value);
                        trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                    }
                    // report to the frontend
                    this.report(msg);
                } else {
                    if(!report_only){
                        if (options.is_masstort) {
                            this.trackFacebookEvent(key);
                        }
                        if(google_tracking === 'async') {
                            // send the trackFunnelEvent method to google
                            try {
                                gtag('event', action, gtagFieldsObject);
                            } catch(err) {
                                console.log('2.Unable to call google analytics asynchronous method: trackFunnelEvent');
                            }
                        }
                    }
                }
            }

            // increment repeated attempts
            trace.repeats_attempted++;

            // track the analytics event
            this.track(key, trace);

            return false;
        }
    }

    noloPathAnalytics.prototype.leadTypeConversionFunnel = function(key, param, extra) {
        var lead_type = $('#nolopath').data().lead_type;
        var targetType = extra && extra.lead_type?extra.lead_type:'';
        var targetTypeExclused = extra && extra.lead_type_exclused?extra.lead_type_exclused:'';
        if ( targetType == lead_type || ( targetTypeExclused !== lead_type && targetTypeExclused.length>0 )) {

            // grab options
            var options = this.options;
    
            // determine if this will actually trigger google analytics '_trackEvent' method
            var debug = options.debug;
    
            // determine if this event has ran before
            var track = this.track(key);
    
            // trace object for storing tracking information
            var trace = this.getTrace(key, param, extra);

            var conversion_send_to = extra.conversion_send_to;
            // determine if repeated triggers of this analytics handler is allowed
            var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

            // determine if this is for reporting only
            var report_only = this.reportOnly;

            // the required 'action' parameter defines the action of the event (e.g. "Play")
            var action = extra.action;

            // determine the google analytics code being used
            var google_tracking = options.google_tracking;

            // fire analytics if trackFunnelEvent function was not fired before
            if(!track || repeats_allowed){
                // indicate tracking status to true
                trace.status = true;

                // set alert type

                var gtagFieldsObject = {
                    send_to: conversion_send_to
                };
                
                if(!report_only){
                    if (options.is_masstort) {
                        this.trackFacebookEvent(key);
                    }
                    if(google_tracking === 'async') {
                        // send the trackFunnelEvent method to google
                        if(conversion_send_to == 'AW-854749324/OKeBCPrD3qcDEIzhyZcD'){
                            try {
                                var age = parseInt(document.querySelector('#nolopath-q1066').options[document.querySelector('#nolopath-q1066').selectedIndex].text);
                                if(50 <= age && age <= 54){
                                    gtagFieldsObject.value = '70';
                                    gtagFieldsObject.currency = 'USD';
                                } 
                                else if(55 <= age && age <= 63){
                                    gtagFieldsObject.value = '100';
                                    gtagFieldsObject.currency = 'USD';
                                } 
                                gtag('event', action, gtagFieldsObject);
                            } catch (err) {
                                console.log('3.Unable to call google analytics asynchronous method: trackFunnelEvent');
                            }
                        } else {
                            try {
                                gtag('event', action, gtagFieldsObject);
                            } catch(err) {
                                console.log('3.Unable to call google analytics asynchronous method: trackFunnelEvent');
                            }
                        }
                        
                    }
                }
            }

            // increment repeated attempts
            trace.repeats_attempted++;

            // track the analytics event
            this.track(key, trace);

            return false;
        }
    }

    noloPathAnalytics.prototype.trackFunnelEvent = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // determine the google analytics account id
        var google_id = options.google_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.category;
        category = category.replaceAll('[aop]',$('#nolopath').data().practiceAreaId==1?'':$('#nolopath').data().practiceAreaId);

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action = extra.action;

        // the optional 'label' parameter provides a more detailed descriptor of the event for reporting
        var opt_label = extra.opt_label || '';

        // the optional 'value' parameter is required to be a number
        var opt_value = $.isNumeric(extra.opt_value) ? Number(extra.opt_value) : 0;

        // the optional 'noninteraction' parameter is required to be a boolean
        // -----
        // @note
        // + by default, Google Analytics sets this value to false, if not declared explicitly
        // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
        //   if not explicitly declared through the configuration
        var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

        // fire analytics if trackFunnelEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            var gtagFieldsObject = {
                send_to: google_id,
                event_category: category,
                event_label: opt_label,
                nonInteraction: opt_noninteraction
            };
            if(debug){
                // fire only console commands
                if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq("send")');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, opt_label',  opt_label);
                    trace.setMessage('method param, opt_value',  opt_value);
                    trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if (options.is_masstort) {
                        this.trackFacebookEvent(key);
                    }
                    if(google_tracking === 'async') {
                        // send the trackFunnelEvent method to google
                        try {
                            gtag('event', action, gtagFieldsObject);
                        } catch(err) {
                            console.log(typeof gtag)
                            console.log('4.Unable to call google analytics asynchronous method: trackFunnelEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);

        return false;
    }

    // only handle step-1 semFormUserEngaged here; other facebook events are handled elsewhere
    noloPathAnalytics.prototype.trackFacebookEvent = function(key) {
        var isStep1Engaged = key.includes("semFormUserEngaged_step-1_0");
        if (isStep1Engaged) {
            fbq('trackCustom', 'Masstort Start Form');
        }
    };

    /*****
     * pixelFire()
     * - generates 1x1 tracking pixels of the passed url
     * + params: param (string)
     */
    noloPathAnalytics.prototype.pixelFire = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will create a vendor pixel or a debugging pixel
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // always fire the event by default
        var fire_event = true;

        // grab debugging pixel
        var debug_pixel = this.debugPixel;

        // determine pixel url components
        var url = param.split('?');
        var vendor_domain = url[0];
        var vendor_params = url[1];
        var idx = 'nolo_idx=' + options.timestamp;
        var pixel;

        // append timestamp for cache protection
        if (typeof vendor_params === 'undefined'){
            vendor_params = idx;
        } else {
            vendor_params += '&' + idx;
        }

        // assemble final pixel url
        pixel = vendor_domain + '?' + vendor_params;

        // conversion pixels can have multiple different pathnames ('confirm', 'confirm/notused', etc)
        // when specified, fire the pixel only if the pathname matches the route
        if(extra['confirm-route']){
            fire_event = location.pathname.endsWith(extra['confirm-route']);
        }

        // fire analytics if pixelFire function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            if(debug){
                if(fire_event){
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: pixelFire() function FIRED!<br /> method key: '+key+' <br /> method call: document.body.appendChild()<br />method param: '+pixel+'</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: pixelFire() function FIRED!');
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', 'document.body.appendChild()');
                    trace.setMessage('method param', pixel);

                    // report to the frontend
                    this.report(msg);

                    // create a pixel to the pixeltest url
                    debug_pixel += '?tracking_url_key=' + key + '&vendor_domain=' + encodeURIComponent(vendor_domain) + '&' + vendor_params;

                    // create the pixel
                    this.setPixel(debug_pixel);
                }
            } else {
                if(!report_only && fire_event){
                    // create the pixel
                    this.setPixel(pixel);
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }


    /*****
     * trackOptimizely()
     * - calls upon the trackEvent method of optimizely
     * + params: param (string)
     */
    noloPathAnalytics.prototype.trackOptimizely = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will send an Optimizely event
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // ensure that region parameter is labeled properly with the region id
        if (extra.region){
            param = param.replace('!_regionId', extra.region);
        } else {
            param = param.replace('_!_regionId', 'none');
        }
        if (extra.regionGeneral){
            param = param.replace('!_regionGeneral', extra.regionGeneral);
        } else {
            param = param.replace('_!_regionGeneral', 'undefined_region');
        }

        // optimizely x event tags
        var tags = {
            step: extra.step,
            path: extra.path,
            block: extra.block || 'none',
            region: extra.regionGeneral || 'undefined'
        };

        // fire analytics if trackOptimizely function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');
            if(debug){
                msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackOptimizely() function FIRED!<br /> method key: '+key+' <br /> method call: window.optimizely.push["trackEvent"]<br /> method param: '+param+'</p>';

                // set trace messages for output
                trace.setMessage('semAnalytics Plugin: trackOptimizely() function FIRED!');
                trace.setMessage('method key', key);
                trace.setMessage('method call', 'window.optimizely.push({type: "event"})');
                trace.setMessage('method param', param);

                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    window['optimizely'] = window['optimizely'] || [];
                    window['optimizely'].push({
                        type: 'event',
                        eventName: param,
                        tags: tags
                    });
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);

        return false;
    }

    /*****
     * !REMOVED! - EHCS-3767: Will opt for Convert Snippet
     * trackAdobe()
     * - calls upon the trackEvent method of Adobe Target
     * + params: param (string)
     */
    // noloPathAnalytics.prototype.trackAdobe = function(key, param, extra) {
    //     // grab options
    //     var options = this.options;

    //     // determine if this will send an Adobe Target event
    //     var debug = options.debug;

    //     // determine if this event has ran before
    //     var track = this.track(key);

    //     // trace object for storing tracking information
    //     var trace = this.getTrace(key, param, extra);

    //     // messages array for outputting the debugging messages
    //     var msg = [];

    //     // determine if repeated triggers of this analytics handler is allowed
    //     var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

    //     // determine if this is for reporting only
    //     var report_only = this.reportOnly;
    //     if(typeof extra === 'object'){
    //         report_only = extra.report_only || report_only;
    //     }

    //     // ensure that region parameter is labeled properly with the region id
    //     if (extra.region){
    //         param = param.replace('!_regionId', extra.region);
    //     } else {
    //         param = param.replace('_!_regionId', 'none');
    //     }
    //     if (extra.regionGeneral){
    //         param = param.replace('!_regionGeneral', extra.regionGeneral);
    //     } else {
    //         param = param.replace('_!_regionGeneral', 'undefined_region');
    //     }

    //     // fire analytics if trackAdobe function was not fired before
    //     if(!track || repeats_allowed){
    //         // indicate tracking status to true
    //         trace.status = true;
    //         // set alert type
    //         trace.setAlert('info');
    //         if(debug){
    //             msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackAdobe() function FIRED!<br /> method key: '+key+' <br /> method call: adobe.target.trackEvent({"mbox":"{{Goal Name}}"});<br /> method param: '+param+'</p>';
    //             // set trace messages for output
    //             trace.setMessage('semAnalytics Plugin: trackAdobe() function FIRED!');
    //             trace.setMessage('method key', key);
    //             trace.setMessage('method call', 'adobe.target.trackEvent({"mbox":"{{Goal Name}}"});');
    //             trace.setMessage('method param', param);

    //             // report to the frontend
    //             this.report(msg);
    //         } else {
    //             if(!report_only){
    //                 // we depend on at.js from NCMS to create adobe object
    //                 // at.js loads slower than onSemPageLoad trigger
    //                 if (typeof adobe != 'undefined') {
    //                     adobe.target.trackEvent({'mbox':param});
    //                 } else {
    //                     // try again in 2.5 sec if 'adobe' object hasn't been loaded yet.
    //                     setTimeout(function() {
    //                         if (typeof adobe != 'undefined') {
    //                             try {
    //                                 adobe.target.trackEvent({'mbox':param});
    //                             } catch (e) {
    //                                 console.error(e);
    //                             }
    //                         }
    //                         // if adobe is still undefined check if at.js is loaded
    //                         // if at.js doesn't load it's most likely not enabled in NCMS admin for that domain
    //                     }, 2500)
    //                 }                
    //             }
    //         }
    //     }

    //     // increment repeated attempts
    //     trace.repeats_attempted++;

    //     // track the analytics event
    //     this.track(key, trace);

    //     return false;
    // }

    /*****
     * setSmartlyParams()
     * + params: param (string)
     */
    noloPathAnalytics.prototype.setSmartlyParams = function(key, param, extra) {
        // grab the element
        var $elm = this.$element;

        // grab options
        var options = this.options;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // find the 'hidden inputs' container
        var $hidden = $elm.find(options.hiddenQuestions);

        // determine target hidden field
        var $field;
        var field = null;
        if(typeof extra === 'object'){
            field = extra.field || field;
        }

        var query = new URLSearchParams(location.search);
        
        // fire setSmartlyParams only if fb_ad_id exists
        if (query.get('fb_ad_id')) {
            switch (field) {
                case 'smartly_fb_ad_id': 
                    param = query.get('fb_ad_id');
                    break;
                case 'smartly_fb_click_time': 
                    var timestamp = Math.round(this.options.timestamp / 1000) - (7 * 3600);
                    param = timestamp;
                    break;
                default:
                    break;
                
    
            }
            // fire analytics if setSmartlyParams function was not fired before
            if(!track || repeats_allowed){
                // indicate tracking status to true
                trace.status = true;

                // set alert type
                trace.setAlert('info');

                // find the nanigans parameter hidden field
                $field = $hidden.find('input[name="'+field+'"]');

                if ($field.length > 0) {
                    msg = '<p class="sem-debug-msg info small">FIELDS ALREADY EXISTS: ' +field+' => '+ $field.val() + '</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: setSmartlyParams() function FIRED!');
                    trace.setMessage('FIELD ALREADY EXISTS!');
                    trace.setMessage('field', field);
                    trace.setMessage('field value', $field.val());
                } else {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: setSmartlyParams() function FIRED!<br /> method key: '+key+' <br /> method call: this.setNanigansAccount()<br /> method param: '+param+'<br /> method extra: '+field+'</p>';

                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: setSmartlyParams() function FIRED!');
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', 'this.setSmartlyParams()');
                    trace.setMessage('method param', param);
                    trace.setMessage('method extra', field);

                    // set hidden field
                    this.setHiddenField(field, param);
                }

                // report to the frontend
                this.report(msg);
            }

            // increment repeated attempts
            trace.repeats_attempted++;

            // track the analytics event
            this.track(key, trace);
        }
        
        return false;
    }


    /*****
     * setNanigansAccount()
     * - set the app_id for use with semForm plugin
     * + params: param (string)
     */
    noloPathAnalytics.prototype.setNanigansAccount = function(key, param, extra) {
        // grab the element
        var $elm = this.$element;

        // grab options
        var options = this.options;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // find the 'hidden inputs' container
        var $hidden = $elm.find(options.hiddenQuestions);

        // determine target hidden field
        var $field;
        var field = null;
        if(typeof extra === 'object'){
            field = extra.field || field;
        }

        // fire analytics if setAccount function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            // find the nanigans parameter hidden field
            $field = $hidden.find('input[name="'+field+'"]');

            if ($field.length > 0) {
                msg = '<p class="sem-debug-msg info small">FIELDS ALREADY EXISTS: ' +field+' => '+ $field.val() + '</p>';

                // set trace messages for output
                trace.setMessage('semAnalytics Plugin: setNanigansAccount() function FIRED!');
                trace.setMessage('FIELD ALREADY EXISTS!');
                trace.setMessage('field', field);
                trace.setMessage('field value', $field.val());
            } else {
                msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: setNanigansAccount() function FIRED!<br /> method key: '+key+' <br /> method call: this.setNanigansAccount()<br /> method param: '+param+'<br /> method extra: '+field+'</p>';

                // set trace messages for output
                trace.setMessage('semAnalytics Plugin: setNanigansAccount() function FIRED!');
                trace.setMessage('method key', key);
                trace.setMessage('method call', 'this.setNanigansAccount()');
                trace.setMessage('method param', param);
                trace.setMessage('method extra', field);

                // set hidden field
                this.setHiddenField(field, param);
            }

            // report to the frontend
            this.report(msg);
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }


    /*****
     * nanigansPixelFire()
     * - generates 1x1 tracking pixels of the passed url
     * + params: param (string)
     */
    noloPathAnalytics.prototype.nanigansPixelFire = function(key, param, extra) {
        // grab the element
        var $elm = this.$element;

        // grab options
        var options = this.options;

        // determine if this will create a vendor pixel or a debugging pixel
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        var fullUrl = location.href;

        if (key === 'nanigans_standard_semConversion_goal_0' && isAjaxForm(fullUrl)) {
            var nanName = ajaxFormConfirmRoute(fullUrl, extra.leadsapi);
            param = param.replace('form_complete', nanName);
        }

        var hasConfirmRoute = false;
        var confirmRoute = '';
        
        // grab debugging pixel
        var debug_pixel = this.debugPixel;

        // determine pixel url components
        var url = param.split('?');
        var vendor_domain = url[0];
        var vendor_params = url[1];
        var idx = 'nolo_idx=' + options.timestamp;
        var pixel;

        // append timestamp for cache protection
        if (typeof vendor_params === 'undefined'){
            vendor_params = idx;
        } else {
            vendor_params += '&' + idx;
        }

        // validate nanigans parameters
        var nan_params = ['nan_app_id', 'nan_type', 'nan_name', 'nan_user_id', 'nan_ut1'];
        var param_search, param_replace, mail_hash;
        
        // check if vendor has 'confirm-route' and replace nanigans tag's name with new name if it exists
        if (vendor_params.indexOf('confirm-route') > -1) {
            for (var route in extra['confirm-route']) {
                if (location.pathname.endsWith(route)) {
                    hasConfirmRoute = true;
                    confirmRoute = route;
                }
            }
            var vendor_paramsArr = vendor_params.split('&');
            // iterate through all vendor_params and remove all 'confirm-route' parts so they are not sent
            vendor_params.split('&').forEach(function(parameter, index) {
                if (parameter.indexOf('confirm-route') > -1) {
                    // remove unneeded confirm-route
                    vendor_paramsArr.splice(vendor_paramsArr.indexOf(parameter), 1);
                } else if (parameter.indexOf('name=') > -1 && hasConfirmRoute) {
                    // replace nanigans tag name with new name from confirm-route
                    vendor_paramsArr[index] = 'name=' + extra['confirm-route'][confirmRoute]['name'];
                }
            });
            vendor_params = vendor_paramsArr.join('&');
        }

        for (var i=0; i < nan_params.length; i++){
            param_search = vendor_params.search('%25'+nan_params[i]+'%25');

            if(param_search > 0){
                param_replace = encodeURIComponent($elm.find('input[name="'+nan_params[i]+'"]').val() || '');
                if(nan_params[i] === 'nan_ut1'){
                    // get the updated 'mail_hash' from leads api, if detected
                    mail_hash = (extra.leadsapi && extra.leadsapi.user && extra.leadsapi.user.mail_hash) ? extra.leadsapi.user.mail_hash: null;
                    param_replace = mail_hash || param_replace
                }
                vendor_params = vendor_params.replace('%25'+nan_params[i]+'%25', param_replace);
            }
        }

        // assemble final pixel url
        pixel = vendor_domain + '?' + vendor_params;

        // fire analytics if pixelFire function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            if(debug){
                msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: nanigansPixelFire() function FIRED!<br /> method key: '+key+' <br /> method call: document.body.appendChild()<br />method param: '+pixel+'</p>';

                // set trace messages for output
                trace.setMessage('semAnalytics Plugin: nanigansPixelFire() function FIRED!');
                trace.setMessage('method key', key);
                trace.setMessage('method call', 'document.body.appendChild()');
                trace.setMessage('method param', pixel);

                // report to the frontend
                this.report(msg);

                // create a pixel to the pixeltest url
                debug_pixel += '?tracking_url_key=' + key + '&vendor_domain=' + encodeURIComponent(vendor_domain) + '&' + vendor_params;

                // create the pixel
                this.setPixel(debug_pixel);
            } else {
                if(!report_only){
                    // create the pixel
                    this.setPixel(pixel);
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);

        return false;
    }


    var ajaxFormConfirmRoute = function (fullUrl, leadsapi) {
        var nanName = '';
        
        if (fullUrl.includes('heartburn') && fullUrl.includes('variant3a')) {
            var a_581 = leadsapi.nolopath['questions%5B581%5D'].charAt(0);
            var a_591 = leadsapi.nolopath['questions%5B591%5D'].charAt(0);
            var a_601 = leadsapi.nolopath['questions%5B601%5D'].charAt(0);
            if (a_581 === '2' || a_591 === '2') {
                nanName = 'hard_complete';
            } else if (a_601 === '2' || a_601 === '7') {
                nanName = 'soft_complete';
            } else {
                nanName = 'form_complete';
            }
        } else if (fullUrl.includes('vaping') && fullUrl.includes('variant2a')) {
            var a_541 = leadsapi.nolopath['questions%5B541%5D'].charAt(0);
            var a_561 = leadsapi.nolopath['questions%5B561%5D'].charAt(0);
            var a_571 = leadsapi.nolopath['questions%5B571%5D'].charAt(0);
            if (a_541 === '1' && a_561 === '2' && a_571 === '3') {
                nanName = 'soft_complete';
            } else if (a_541 === '1') {
                nanName = 'form_complete';
            } else {
                nanName = 'hard_complete';
            }
        } else if (fullUrl.includes('talcumpowder') && fullUrl.includes('bmlegal-help')
            || fullUrl.includes('talcumpowder') && fullUrl.includes('form3bm')) {
            var a_661 = leadsapi.nolopath['questions%5B661%5D'].charAt(0);
            var a_671 = leadsapi.nolopath['questions%5B671%5D'].charAt(0);
            var a_681 = leadsapi.nolopath['questions%5B681%5D'].charAt(0);
            var a_691 = leadsapi.nolopath['questions%5B691%5D'].charAt(0);
            if (a_661 === '2' || a_671 === '2' || a_681 === '1' || a_691 === '3') {
                nanName = 'hard_complete';
            } else {
                nanName = 'form_complete';
            }
        }
        
        return nanName;
    };


    var isAjaxForm = function (fullUrl) {
        if (fullUrl.includes('vaping') && fullUrl.includes('variant2a')
            || (fullUrl.includes('heartburn') && fullUrl.includes('variant3a'))
            || (fullUrl.includes('talcumpowder') && fullUrl.includes('form3bm'))
            || (fullUrl.includes('talcumpowder') && fullUrl.includes('bmlegal-help')) ) {
            return true;
        }
        
        return false;
    };
    

    noloPathAnalytics.prototype.trackQuestionEvent = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }
        // determine the google analytics account id
        var google_id = options.google_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.category;

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action = extra.action;

        // the optional 'label' parameter provides a more detailed descriptor of the event for reporting
        var opt_label = extra.opt_label || '';

        // the optional 'value' parameter is required to be a number
        var opt_value = $.isNumeric(extra.opt_value) ? Number(extra.opt_value) : 0;

        // the optional 'noninteraction' parameter is required to be a boolean
        // -----
        // @note
        // + by default, Google Analytics sets this value to false, if not declared explicitly
        // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
        //   if not explicitly declared through the configuration
        var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

        // fire analytics if trackFunnelEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            var gtagFieldsObject = {
                send_to: google_id,
                event_category: category,
                event_label: opt_label,
                nonInteraction: opt_noninteraction
            };
            if(debug){
                // fire only console commands
                if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq("send")');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, opt_label',  opt_label);
                    trace.setMessage('method param, opt_value',  opt_value);
                    trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'async') {
                        // send the trackFunnelEvent method to google
                        try {
                            gtag('event', action, gtagFieldsObject);
                        } catch(err) {
                            console.log('5.Unable to call google analytics asynchronous method: trackFunnelEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }

    noloPathAnalytics.prototype.trackQuestionAnsweredEvent = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }

        // determine the google analytics 4 account id
        var google_id = options.google_ga4_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // set aop specific custom question label and event step
        var pid = $('body').attr('data-pid');
        if( pid && extra.is_common_question ) {
            var common_data = extra.common_data['practice-area'][pid] || '';
            if( common_data != '' ) {
                extra.question_label = common_data.question_label;
                extra.event_step = common_data.event_step;
            }
        }

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.question_answered;

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action = 'leadpath_' + extra.event_step;

        // the optional 'label' parameter provides a more detailed descriptor of the event for reporting
        var opt_label = extra.question_label || '';

        // the optional 'value' parameter is required to be a number
        var opt_value = $.isNumeric(extra.answer_value) ? Number(extra.answer_value) : 0;

        var opt_question_id = 'q' + extra.question_id;
        var opt_answered_value = '';
        var opt_num = '';
        var opt_answer = '';
        var input_obj = $('#nolopath-' + opt_question_id);

        // EHCS-2105 - GA4: DUI/DWI path: first question event is not triggered
        if(typeof input_obj == 'undefined' || Object.keys(input_obj).length === 0 || ( typeof input_obj == 'object' && input_obj.length === 0 ) ) {
            input_obj = $('#nolopath-practice-area-select').find('option:selected').val() == extra.question_id ? $('#nolopath-practice-area-select') : undefined;
            opt_question_id = 'practice-area-select';
        }

        if(!extra.is_common_question) {
            var opt_question_label = $('.control-label[for="nolopath-' + opt_question_id + '"]').clone().children().remove().end().text();
            if(typeof opt_question_label != 'undefined' || opt_question_label != null) {
                extra.question_label = opt_question_label.trim();
                opt_label = opt_question_label.trim();
            }
        }

        var dateNowObj = Date.now();
        var dateObj = new Date(dateNowObj);
        var answered_at = dateObj.toDateString() + ' ' + dateObj.toTimeString();

        if(typeof input_obj.prop('tagName') == 'undefined') {
            return false;
        }

        switch (input_obj.prop('tagName')) {
            case 'SELECT':
                extra.answer_label = input_obj.find('option:selected').text() || '';
                opt_answered_value = input_obj.find('option:selected').val();
                if(opt_answered_value.includes(':')) {
                    opt_num = opt_answered_value.split(':')[0];
                    opt_answer = opt_answered_value.split(':')[1];
                    opt_answered_value = opt_num;
                } else {
                    opt_answer = extra.answer_label;
                }
                action = 'leadpath_' + extra.event_step + '_option'+opt_answered_value;
                if(extra.event_type == 'boolean_dropdown') {
                    action = 'leadpath_' + extra.event_step + '_' + opt_answer.trim().toLowerCase();
                } else if(extra.ui_dropdown_answer_option) {
                    action = 'leadpath_' + extra.event_step + '_option'+input_obj.find('option:selected').index();
                }
                break;
            default:
                switch(input_obj.attr('type')){
                    case 'checkbox':
                        extra.answer_label = input_obj.attr('data-text' || '');
                        opt_answered_value = input_obj.val();
                        break;

                    case 'radio':
                        extra.answer_label = input_obj.attr('data-text') || '';
                        opt_answered_value = input_obj.val();
                        break;

                    default:
                        extra.answer_label = input_obj.attr('placeholder') || '';
                        opt_answered_value = input_obj.val();
                        break;
                }
                break;
        }

        // the optional 'label' parameter provides a more detailed descriptor of the event for reporting
        var question_answered = extra.question_answered || '';
        var question_label = extra.question_label || '';
        var question_id = extra.question_id || '';
        var answer_label = extra.answer_label || '';
        var answer_value = opt_answered_value || '';

        // the optional 'noninteraction' parameter is required to be a boolean
        // -----
        // @note
        // + by default, Google Analytics sets this value to false, if not declared explicitly
        // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
        //   if not explicitly declared through the configuration
        var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

        // fire analytics if trackFunnelEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            var gtagFieldsObject = {
                send_to: google_id,
                event_category: category,
                event_label: opt_label,
                question_label: question_label,
                question_id: question_id,
                answer_label: answer_label,
                answer_value: answer_value,
                timestamp: answered_at,
                nonInteraction: opt_noninteraction
            };

            if(debug){
                // fire only console commands
                if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq("send")');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, opt_label',  opt_label);
                    trace.setMessage('method param, timestamp',  answered_at);
                    trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'async') {
                        try {
                            gtag('event', action, gtagFieldsObject);
                        } catch(err) {
                            console.log('6.Unable to call google analytics asynchronous method: trackFunnelEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }

    noloPathAnalytics.prototype.trackLeadPathSubmitEvent = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }
        // determine the google analytics 4 account id
        var google_id = options.google_ga4_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.category;

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action = 'undefined' != extra.regionGeneral ? extra.regionGeneral + '_leadpath_confirmation' : 'bottom_leadpath_confirmation';

        var dateNowObj = Date.now();
        var dateObj = new Date(dateNowObj);
        var submitted_at = dateObj.toDateString() + ' ' + dateObj.toTimeString();

        // the optional 'noninteraction' parameter is required to be a boolean
        // -----
        // @note
        // + by default, Google Analytics sets this value to false, if not declared explicitly
        // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
        //   if not explicitly declared through the configuration
        var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

        // fire analytics if trackFunnelEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            var gtagFieldsObject = {
                send_to: google_id,
                event_category: category,
                timestamp: submitted_at,
                nonInteraction: opt_noninteraction
            };

            if(debug){
                // fire only console commands
                if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq("send")');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, submitted_at',  submitted_at);
                    trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'async') {
                        // send the trackFunnelEvent method to google
                        try {
                            gtag('event', action, gtagFieldsObject);
                        } catch(err) {
                            console.log('Unable to call google analytics 4 asynchronous method: trackFunnelEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }

    noloPathAnalytics.prototype.trackStepEvaluationEvent = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }
        // determine the google analytics 4 account id
        var google_id = options.google_ga4_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.category;

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action = extra.action || 'Get Free Evaluation';

        if( extra.event_step != undefined ) {
            action = 'leadpath_' + extra.event_step;
        }

        var dateNowObj = Date.now();
        var dateObj = new Date(dateNowObj);
        var submitted_at = dateObj.toDateString() + ' ' + dateObj.toTimeString();

        // the optional 'noninteraction' parameter is required to be a boolean
        // -----
        // @note
        // + by default, Google Analytics sets this value to false, if not declared explicitly
        // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
        //   if not explicitly declared through the configuration
        var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

        // fire analytics if trackFunnelEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            var gtagFieldsObject = {
                send_to: google_id,
                event_category: category,
                timestamp: submitted_at,
                nonInteraction: opt_noninteraction
            };

            if(debug){
                // fire only console commands
                if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq("send")');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, submitted_at',  submitted_at);
                    trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'async') {
                        // send the trackFunnelEvent method to google
                        try {
                            gtag('event', action, gtagFieldsObject);
                        } catch(err) {
                            console.log('Unable to call google analytics 4 asynchronous method: trackFunnelEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }

    noloPathAnalytics.prototype.trackFormSubmitEvent = function(key, param, extra) {
        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }
        // determine the google analytics 4 account id
        var google_id = options.google_ga4_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.category;

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action = extra.action || 'Get Free Evaluation';

        if( extra.event_step != undefined ) {
            action = 'leadpath_' + extra.event_step;
        }

        var dateNowObj = Date.now();
        var dateObj = new Date(dateNowObj);
        var submitted_at = dateObj.toDateString() + ' ' + dateObj.toTimeString();

        // the optional 'noninteraction' parameter is required to be a boolean
        // -----
        // @note
        // + by default, Google Analytics sets this value to false, if not declared explicitly
        // + for noloPathAnalytics purposes, we are settings this by default to 'TRUE'
        //   if not explicitly declared through the configuration
        var opt_noninteraction = (typeof extra.opt_noninteraction === 'boolean') ? extra.opt_noninteraction : true;

        // fire analytics if trackFunnelEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');

            var gtagFieldsObject = {
                send_to: google_id,
                event_category: category,
                timestamp: submitted_at,
                nonInteraction: opt_noninteraction
            };

            if(debug){
                // fire only console commands
                if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq("send")');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, submitted_at',  submitted_at);
                    trace.setMessage('method param, opt_noninteraction',  opt_noninteraction);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'async') {
                        // send the trackFunnelEvent method to google
                        try {
                            gtag('event', action, gtagFieldsObject);
                        } catch(err) {
                            console.log('Unable to call google analytics 4 asynchronous method: trackFunnelEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }

    noloPathAnalytics.prototype.trackLeadGenerationEvent = function(key, param, extra) {

        var hiddenData = $('body').find('input[name="lead_submission_response"]').val();
        var jsonData = hiddenData ? JSON.parse(hiddenData) : {};

        // grab options
        var options = this.options;

        // determine if this will actually trigger google analytics '_trackEvent' method
        var debug = options.debug;

        // determine if this event has ran before
        var track = this.track(key);

        // trace object for storing tracking information
        var trace = this.getTrace(key, param, extra);

        // messages array for outputting the debugging messages
        var msg = [];

        // determine if repeated triggers of this analytics handler is allowed
        var repeats_allowed = trace.repeats_allowed || this.repeatsAllowed;

        // determine if this is for reporting only
        var report_only = this.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
        }
        // determine the google analytics 4 account id
        var google_id = options.google_ga4_id;

        // determine the google analytics code being used
        var google_tracking = options.google_tracking;

        // the required 'category' parameter defines the general event category (e.g. "Videos")
        var category = extra.category;

        // the required 'action' parameter defines the action of the event (e.g. "Play")
        var action =  extra.action;

        var practice_area = Object.keys(jsonData).length === 0 ? extra.practice_area : jsonData.practice_area_name;
        var lead_id = Object.keys(jsonData).length === 0 ? extra.lead_id : jsonData.request_id;
        var user_id_data = Object.keys(jsonData).length === 0 ? extra.user_id : jsonData.user.mail;
        var channel = extra.channel;

        // Form request_id encrypted using AES encryption algorithm
        var key = CryptoJS.enc.Utf8.parse($.NOLO_PATH_CONSTANTS.ga4Crypto.cred[$.NOLO_PATH_CONSTANTS.ga4Crypto.method].key);
        var iv = CryptoJS.enc.Utf8.parse($.NOLO_PATH_CONSTANTS.ga4Crypto.cred[$.NOLO_PATH_CONSTANTS.ga4Crypto.method].iv);

        var encrypted = CryptoJS.AES.encrypt(
            user_id_data,
            key,
            {
                iv: iv,
                mode: CryptoJS.mode.CBC,
            }
        );

        var encrypted_user_id = encrypted.toString();

        // fire analytics if trackFunnelEvent function was not fired before
        if(!track || repeats_allowed){
            // indicate tracking status to true
            trace.status = true;

            // set alert type
            trace.setAlert('info');


            const zipRegex = /^(00[67]\d{2}|009\d{2})(-\d{4})?$/;
            const isTestLead = zipRegex.test(jsonData.zip) ? "Yes" : "No";

            var gtagFieldsObject = {
                send_to: google_id,
                event_category: category,
                channel: channel,
                practice_area: practice_area,
                lead_id: lead_id,
                test_lead: isTestLead,
                user_id: encrypted_user_id
            };

            if(debug){
                // fire only console commands
                if(google_tracking === 'async') {
                    msg = '<p class="sem-debug-msg info small">semAnalytics Plugin: trackFunnelEvent() function FIRED!<br />Google Analytics Tracking Code: ASYNCHRONOUS<br />google_id: ' + google_id + '<br />method key: ' + key + '<br />method call: _gaq.push(["_trackEvent"]<br />method param, category: ' + category + '<br />method param, action: ' + action + '<br />method param, opt_label: ' + opt_label + '<br />method param, opt_value: ' + opt_value + '<br />method param, opt_noninteraction: ' + opt_noninteraction +'</p>';
                    // set trace messages for output
                    trace.setMessage('semAnalytics Plugin: trackFunnelEvent() function FIRED!');
                    trace.setMessage('Google Analytics Tracking Code', 'ASYNCHRONOUS');
                    trace.setMessage('google_id', google_id);
                    trace.setMessage('method key', key);
                    trace.setMessage('method call', '_gaq("send")');
                    trace.setMessage('method param, category', category);
                    trace.setMessage('method param, action',  action);
                    trace.setMessage('method param, channel',  channel);
                    trace.setMessage('method param, practice_area',  practice_area);
                    trace.setMessage('method param, lead_id',  lead_id);
                    trace.setMessage('method param, user_id',  encrypted_user_id);
                }
                // report to the frontend
                this.report(msg);
            } else {
                if(!report_only){
                    if(google_tracking === 'async') {
                        // send the trackFunnelEvent method to google
                        try {
                            gtag('event', action, gtagFieldsObject);
                        } catch(err) {
                            console.log('Unable to call google analytics 4 asynchronous method: trackLeadGenerationEvent');
                        }
                    }
                }
            }
        }

        // increment repeated attempts
        trace.repeats_attempted++;

        // track the analytics event
        this.track(key, trace);
        return false;
    }

    /*****
         * trackPulsePointEvent()
         * + params: param (string)
         */
    noloPathAnalytics.prototype.trackPulsePointEvent = function(key, param, extra) {
        // don't fire pageload on an NCMS page
        var isNCMS;
        try {
            isNCMS = NCMS;
        } catch (error) {
            isNCMS == null;
        }

        if (extra['e'] == '1' && (isNCMS != null)) {
            return;
        }

        var $t = this;
        
        if ((typeof window.ehcsIsoCode !== 'undefined' &&  window.ehcsIsoCode == "US")) {
            firePPevent(key, param, extra, $t);
        } else {
            $.ajax({
                url: "https://geocoding.internetbrands.com/geocoding/api/v1.1/getIsoCode",
                type: 'GET',
                success: function(res) {
                    if (res.isoCode == "US") {
                        window.ehcsIsoCode = res.isoCode;
                        firePPevent(key, param, extra, $t);
                        // // grab the element
                        // var $elm = $t.$element;

                        // // grab options
                        // var options = $t.options;

                        // // determine if this event has ran before
                        // var track = $t.track(key);

                        // // trace object for storing tracking information
                        // var trace = $t.getTrace(key, param, extra);

                        // // determine if this is for reporting only
                        // var report_only = $t.reportOnly;
                        // if(typeof extra === 'object'){
                        //     report_only = extra.report_only || report_only;
                        //     if(extra['pageurl']=='pageurl') {
                        //         extra['pageurl'] = location.href;
                        //     }
                        //     if(extra['referrer']=='referrer') {
                        //         // using surl value when domain of url changed(document.referer wont keep pathname)
                        //         var documentReferrer = document.referrer;
                        //         var surl = $("input[name=surl]").val();
                        //         var referrer = null;
                        //         if(documentReferrer.includes(location.hostname)) referrer = documentReferrer;//http referrer would capture same domain full paths
                        //         else if(surl !== location.href && surl) referrer =  surl.includes(document.referrer)?
                        //                                                     surl:
                        //                                                     (documentReferrer.replace(/\/$/, '') + surl);
                        //         extra['referrer'] = referrer;
                        //     }
                        //     if(extra['a']=='aop') {
                        //         extra['a'] = $('#nolopath').data().practiceAreaId==1?'':$('#nolopath').data().practiceAreaId;
                        //     }
                        //     if(extra['eid']=='leads_id') {
                        //         extra['eid'] = $('#nolopath').data().requestId?$('#nolopath').data().requestId:'';
                        //     }
                        //     if(extra['did']=='did_cookie') {
                        //         var match = document.cookie.match(new RegExp('(^| )' + '_ibp' + '=([^;]+)'));
                        //         if (match) {
                        //             var didCookie = match[2];
                        //             extra['did'] = didCookie.match(/0:.*:(.*)/)[1];
                        //         }else{
                        //             extra['did'] = '';
                        //         }
                        //     }
                        //     if(typeof extra['p'] === 'object') {
                        //         extra['p'] = extra['p']['p']?extra['p']['p']:5515;//using staging code instead
                        //     }
                        //     if(extra['articlepage'] !== undefined) {
                        //         var insertNoloPath = document.getElementById("nolopath-insert");
                        //         if(insertNoloPath && !extra['articlepage']) {
                        //             //article page disabling
                        //             console.log("stop firing the pulsepoint event because of articlepage as false")
                        //             return;
                        //         }
                        //     }
                        // }
                        // // fire trackPulsePointEvent
                        // otGPPWait('OTGPPConsent', function(cookieVal) {
                        //     var script = document.createElement('script');
                        //     var scriptSrc = "https://bh.contextweb.com/cp?p="+extra['p']+"&gpp="+cookieVal+"&pageurl="+encodeURIComponent(extra['pageurl']?extra['pageurl']:'')+"&referrer="+encodeURIComponent(extra['referrer']?extra['referrer']:'')+"&ei=&did="+encodeURIComponent(extra['did']?extra['did']:'')+"&huid=&e="+encodeURIComponent(extra['e']?extra['e']:'')+"&eid="+encodeURIComponent(extra['eid']?extra['eid']:'')+"&pvid=&bu="+extra['bu']+"&srid=&a="+extra['a']+"&pa=&pt=" + extra['pt'];

                        //     script.type = "text/javascript";
                        //     script.src = scriptSrc;
                        //     script.classList.add("optanon-category-C0004")
                        //     document.body.appendChild(script);
                        //     script.onload = function () {
                        //         script.src = scriptSrc;
                        //         script.setAttribute("async","");
                        //     }
                        // });
                    }
                }
            });
        }
        
        return false;
    }

    function firePPevent(key, param, extra, t) {
        // grab the element
        var $elm = t.$element;

        // grab options
        var options = t.options;

        // determine if this event has ran before
        var track = t.track(key);

        // trace object for storing tracking information
        var trace = t.getTrace(key, param, extra);

        // determine if this is for reporting only
        var report_only = t.reportOnly;
        if(typeof extra === 'object'){
            report_only = extra.report_only || report_only;
            if(extra['pageurl']=='pageurl') {
                extra['pageurl'] = location.href;
            }
            if(extra['referrer']=='referrer') {
                // using surl value when domain of url changed(document.referer wont keep pathname)
                var documentReferrer = document.referrer;
                var surl = $("input[name=surl]").val();
                var referrer = null;
                if(documentReferrer.includes(location.hostname)) referrer = documentReferrer;//http referrer would capture same domain full paths
                else if(surl !== location.href && surl) referrer =  surl.includes(document.referrer)?
                                                            surl:
                                                            (documentReferrer.replace(/\/$/, '') + surl);
                extra['referrer'] = referrer;
            }
            if(extra['a']=='aop') {
                extra['a'] = $('#nolopath').data().practiceAreaId==1?'':$('#nolopath').data().practiceAreaId;
            }
            if(extra['eid']=='leads_id') {
                extra['eid'] = $('#nolopath').data().requestId?$('#nolopath').data().requestId:'';
            }
            if(extra['did']=='did_cookie') {
                var match = document.cookie.match(new RegExp('(^| )' + '_ibp' + '=([^;]+)'));
                if (match) {
                    var didCookie = match[2];
                    extra['did'] = didCookie.match(/0:.*:(.*)/)[1];
                }else{
                    extra['did'] = '';
                }
            }
            if(typeof extra['p'] === 'object') {
                extra['p'] = extra['p']['p']?extra['p']['p']:5515;//using staging code instead
            }
            if(extra['articlepage'] !== undefined) {
                var insertNoloPath = document.getElementById("nolopath-insert");
                if(insertNoloPath && !extra['articlepage']) {
                    //article page disabling
                    console.log("stop firing the pulsepoint event because of articlepage as false")
                    return;
                }
            }
        }
        // fire trackPulsePointEvent
        otGPPWait('OTGPPConsent', function(cookieVal) {
            var script = document.createElement('script');
            var scriptSrc = "https://bh.contextweb.com/cp?p="+extra['p']+"&gpp="+cookieVal+"&pageurl="+encodeURIComponent(extra['pageurl']?extra['pageurl']:'')+"&referrer="+encodeURIComponent(extra['referrer']?extra['referrer']:'')+"&ei=&did="+encodeURIComponent(extra['did']?extra['did']:'')+"&huid=&e="+encodeURIComponent(extra['e']?extra['e']:'')+"&eid="+encodeURIComponent(extra['eid']?extra['eid']:'')+"&pvid=&bu="+extra['bu']+"&srid=&a="+extra['a']+"&pa=&pt=" + extra['pt'];

            script.type = "text/javascript";
            script.src = scriptSrc;
            script.classList.add("optanon-category-C0004")
            document.body.appendChild(script);
            script.onload = function () {
                script.src = scriptSrc;
                script.setAttribute("async","");
            }
        });
    }

    function otGPPWait(cookieName, callback) {
        const interval = 100;
        const timeout = 10000;
        const start = Date.now();
        function check() {
            const value = Cookies.get(cookieName);
            if (value && (typeof window.ehcsIntrct !== 'undefined' &&  window.ehcsIntrct == true)) {
                window.otGPPFound = true;
                callback(value);
            } else if (Date.now() - start < timeout) {
                setTimeout(check, interval);
            } else {window.otGPPFound = false; callback('');}//cookie not found
        }
        check();
    }


    // noloPathAnalyticsTrace MODEL DEFINITION
    // ================================================================================
    var noloPathAnalyticsTrace = function (status, key, param, extra, alert, trace) {
        var self = this;

        self.status = status || false;
        self.fn_key = key;
        self.fn_param = param;
        self.fn_extra = extra;
        self.trace = [];
        self.repeats_allowed = extra.repeat || false;
        self.repeats_attempted = -1;

        self.setAlert = function(alert){
            switch(alert){
                case 'info':
                self.is_info = true;
                break;

                case 'notice':
                self.is_notice = true;
                break;

                case 'success':
                self.is_success = true;
                break;

                case 'alert':
                case 'error':
                default:
                self.is_alert = true;
                break;
            }
        }

        self.setMessage = function(label, message){
            var msg = {'message':''};
            var noLabel = (typeof label === 'undefined') || (label.length === 0);
            var noMessage = (typeof message === 'undefined') || (message.length === 0);

            if(noMessage && !noLabel){
                msg.message = label;
            }

            if(!noMessage && !noLabel){
                msg.label = label;
                msg.message = message;
            }

            self.trace.push(msg);
        }
    }




    // noloPathAnalytics PLUGIN DEFINITION
    // ================================================================================
    function Plugin(option) {
        // store arguments into a local variable so we can reference it for the public methods
        var args = arguments;

        return this.each(function(idx) {
            var $this   = $(this);
            var data    = $this.data(noloPathAnalytics.DATANAME);
            var options = typeof option == 'object' && option;

            // initialize the plugin for this element for the first time
            if (!data){
                // store the index of this particular instance so we can auto generate ids
                if(typeof options == 'object'){
                    // a configuration object was passed into the plugin
                    // add the 'idx' property into 'options'
                    options.idx = idx;
                } else {
                    // a configuration object was NOT passed into the plugin
                    // declare the 'options' variable as an object with at least the 'idx' property assigned to it
                    options = {
                        'idx': idx,
                    };
                }

                // store the instance of this plugin for this element into memory, if none exists
                // this will initialize the plugin using the 'options' configuration
                $this.data(noloPathAnalytics.DATANAME, (data = new noloPathAnalytics(this, options)));
            }

            // call a public method against the initialized plugin
            if (typeof option == 'string'){
                data[option].apply(this, Array.prototype.slice.call(args, 1));
            }
        })
    }

    // assign a previous plugin definition into another variable for 'noConflict'
    var old = $.fn[noloPathAnalytics.NAME];

    // assign the noloPathAnalytics PLUGIN DEFINITION
    $.fn[noloPathAnalytics.NAME]                = Plugin;

    // assign the noloPathAnalytics PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    $.fn[noloPathAnalytics.NAME]['constructor'] = noloPathAnalytics;




    // noloPathAnalytics NO CONFLICT
    // ================================================================================
    $.fn[noloPathAnalytics.NAME]['noConflict'] = function () {
        $.fn[noloPathAnalytics.NAME] = old;
        return this;
    }




    // noloPathAnalytics DATA-API
    // ================================================================================
    $(document).ready(function(){
        // auto-initialize elements that contain the 'data-toggle="noloPathAnalytics"' attribute
        var $elm = $('[data-toggle="noloPathAnalytics"]');

        // pass a blank object to simplify the initialization
        // default plugin options and data attribute configuration options will be used for data-api initialization
        var option = {};

        // initialize the plugin upon document ready
        Plugin.call($elm, option);
    });
}(jQuery, window, document);
